import { env } from './env';

export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
  },

  auth: {
    login: {
      path: '/login',
      getHref: (redirectTo?: string) => `/login${redirectTo ? `?redirectTo=${redirectTo}` : ''}`,
    },
    logout: {
      path: '/logout',
      getHref: () => '/logout',
    },
    callback: {
      path: env.OIDC_CALLBACK_PATH,
      getHref: () => env.OIDC_CALLBACK_PATH,
    },
  },

  onboarding: {
    path: 'onboarding',
    getHref: () => '/o/onboarding',
  },

  error: {
    path: '/error',
    getHref: () => '/error',
  },

  org: {
    root: {
      path: '/o',
      getHref: () => '/o',
    },
    userProfile: {
      path: 'profile',
      getHref: () => '/o/profile',
    },
    selectedOrg: {
      path: ':orgId',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    dashboard: {
      path: '',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    users: {
      path: 'users',
      getHref: (orgId: string) => `/o/${orgId}/users`,
    },
    user: {
      path: 'users/:userId',
      getHref: (orgId: string, userId: string) => `/o/${orgId}/users/${userId}`,
    },
    roles: {
      path: 'roles',
      getHref: (orgId: string) => `/o/${orgId}/roles`,
    },
    role: {
      path: 'roles/:roleId',
      getHref: (orgId: string, roleId: string) => `/o/${orgId}/roles/${roleId}`,
    },
    orgProfile: {
      path: 'org-profile',
      getHref: (orgId: string) => `/o/${orgId}/org-profile`,
    },
  },

  app: {
    root: {
      path: '',
      getHref: () => '/admin',
    },
    dashboard: {
      path: '',
      getHref: () => '/admin',
    },
    users: {
      path: 'users',
      getHref: () => '/admin/users',
    },
    orgs: {
      path: 'orgs',
      getHref: () => '/admin/orgs',
    },
    roles: {
      path: 'roles',
      getHref: () => '/admin/roles',
    },
    profile: {
      path: 'profile',
      getHref: () => '/admin/profile',
    },
    user: {
      path: 'user/:userId',
      getHref: (userId: string) => `/admin/user/${userId}`,
    },
    apps: {
      path: 'apps',
      getHref: () => '/admin/apps',
    },
    app: {
      path: 'apps/:appId',
      getHref: (appId: string) => `/admin/apps/${appId}`,
    },
  },
} as const;
